// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChipsList__container-e192a5 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}

.ChipsList__title-cb2944 {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-110);
  margin-inline-start: var(--indent-8px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ChipsList__badge-aecf39 {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-110);
}

.ChipsList__container-chip-content-f2b8d7 {
  display: flex;
  align-items: center;
}

.ChipsList__container-chip-bd72fd {
  max-width: 230px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-inline-start: 4px;
  padding-inline-end: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/ChipsList/ChipsList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,sCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.title {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-110);\n  margin-inline-start: var(--indent-8px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.badge {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-110);\n}\n\n.container-chip-content {\n  display: flex;\n  align-items: center;\n}\n\n.container-chip {\n  max-width: 230px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-inline-start: 4px;\n  padding-inline-end: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChipsList__container-e192a5`,
	"title": `ChipsList__title-cb2944`,
	"badge": `ChipsList__badge-aecf39`,
	"container-chip-content": `ChipsList__container-chip-content-f2b8d7`,
	"containerChipContent": `ChipsList__container-chip-content-f2b8d7`,
	"container-chip": `ChipsList__container-chip-bd72fd`,
	"containerChip": `ChipsList__container-chip-bd72fd`
};
module.exports = ___CSS_LOADER_EXPORT___;
